import { ProductReviewTranslations } from '@aboutyou/legacy-shared/src/pages/ProductReview/context/ProductReviewTranslationsProvider'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { useMemo } from 'react'

const useReviewPageTranslations = () => {
  const { t } = useTranslation()
  return useMemo(
    (): ProductReviewTranslations => ({
      sizeRatings: [
        t('Zu klein'),
        t('Etwas klein'),
        t('Passgenau'),
        t('Etwas groß'),
        t('Zu groß'),
      ],
      qualityRatings: [
        t('Sehr schlecht'),
        t('Schlecht'),
        t('In Ordnung'),
        t('Gut'),
        t('Sehr gut'),
      ],
      starRatingTitle: t('Wie bewertest Du das Produkt insgesamt?'),
      sizeRatingTitle: t('Wie bewertest Du die Passform?'),
      qualityRatingTitle: t('Wie bewertest Du die Qualität?'),
      recommendTitle: t('Würdest du das Produkt weiterempfehlen?'),
      selectLabel: t('Bitte auswählen'),
      displayNameLabel: t('Dein Anzeigename'),
      reviewTitle: t('Deine Rezension in einem Satz'),
      reviewText: t('Was sollten andere Kunden über das Produkt wissen?'),
      ratingTitle: t('Rezension verfassen'),
      yesLabel: t('Ja'),
      noLabel: t('Nein'),
      submitButtonText: t('Rezension abgeben'),
      successModalTitle: t('Danke für Deine Rezension'),
      successModalDescription: t(
        'Nach einer kurzen Überprüfung stellen wir deine Rezension online',
      ),
      errorModalTitle: t('Ein Fehler ist aufgetreten'),
      errorModalDescription: t(
        'Bitte warte einen Moment und versuche es dann erneut',
      ),
      alreadyVotedTitle: t('Ein Fehler ist auftreten'),
      alreadyVotedDescription: t(
        'Du kannst nur ein Review pro Produkt schreiben.',
      ),
      errorMessages: {
        minLength: (minChar: number) =>
          t('Bitte gib mindestens {{minChar}} Zeichen ein.', { minChar }),
        maxLength: (maxChar: number) =>
          t('Bitte gib maximal {{maxChar}} Zeichen ein.', { maxChar }),
        required: t('Dieses Feld muss ausgefüllt werden'),
      },
    }),
    [t],
  )
}

export default useReviewPageTranslations
